import { BulkReplacementRadio } from '../../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { GroupsEditMassActionItemType } from '../../typings/groups';
import { MassActionId } from '../../typings/groupsEditState';
import { MinusPhrasesShortLibraryItem } from '../../typings/minusPhraseLibrary';

export const HANDLE_GROUPS_EDIT_MASS_ACTIONS = 'HANDLE_GROUPS_EDIT_MASS_ACTIONS';
export type HANDLE_GROUPS_EDIT_MASS_ACTIONS = typeof HANDLE_GROUPS_EDIT_MASS_ACTIONS;

export interface HandleGroupsEditMassActions {
    type: HANDLE_GROUPS_EDIT_MASS_ACTIONS;
    action: GroupsEditMassActionItemType;
}

export function handleGroupsEditMassActions(action: GroupsEditMassActionItemType): HandleGroupsEditMassActions {
    return {
        type: HANDLE_GROUPS_EDIT_MASS_ACTIONS,
        action
    };
}

export const OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS = 'OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS';
export type OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS = typeof OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS;

export interface OpenMinusPhraseGroupsMassActionsAction {
    type: OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS;
    editorId: MassActionId;
    minusPhrases: string[];
    selectedLibraryList?: MinusPhrasesShortLibraryItem[];
}

export function openMinusPhraseGroupsMassActions(
    editorId: MassActionId,
    minusPhrases: string[],
    selectedLibraryList?: MinusPhrasesShortLibraryItem[]
): OpenMinusPhraseGroupsMassActionsAction {
    return {
        type: OPEN_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
        editorId,
        minusPhrases,
        selectedLibraryList
    };
}

export const ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS = 'ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS';
export type ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS = typeof ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS;

export interface OnAcceptMinusPhraseGroupsMassActionsAction {
    type: ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS;
    massActionId: MassActionId;
}

export function onAcceptMinusPhraseGroupsMassActions(
    massActionId: MassActionId
): OnAcceptMinusPhraseGroupsMassActionsAction {
    return {
        type: ON_ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
        massActionId
    };
}

export const CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO = 'CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO';
export type CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO = typeof CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO;

export interface ChangeMinusPhraseGroupsMassActionsRadioAction {
    type: CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function changeMinusPhraseGroupsMassActions(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): ChangeMinusPhraseGroupsMassActionsRadioAction {
    return {
        type: CHANGE_MINUS_PHRASE_GROUPS_MASS_ACTIONS_RADIO,
        massActionId,
        value
    };
}

export const CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS = 'CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS';
export type CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS = typeof CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS;

export interface CloseMinusPhraseGroupsMassActionsAction {
    type: CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS;
    massActionId: MassActionId;
}

export function closeMinusPhraseGroupsMassActions(massActionId: MassActionId): CloseMinusPhraseGroupsMassActionsAction {
    return {
        type: CLOSE_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
        massActionId
    };
}

export const ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS = 'ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS';
export type ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS = typeof ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS;

export interface AcceptMinusPhraseGroupsMassActionsAction {
    type: ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS;
    massActionId: MassActionId;
}

export function acceptMinusPhraseGroupsMassActions(
    massActionId: MassActionId
): AcceptMinusPhraseGroupsMassActionsAction {
    return {
        type: ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
        massActionId
    };
}

export type GroupsMassAction =
    | OpenMinusPhraseGroupsMassActionsAction
    | AcceptMinusPhraseGroupsMassActionsAction
    | CloseMinusPhraseGroupsMassActionsAction
    | ChangeMinusPhraseGroupsMassActionsRadioAction
    | OnAcceptMinusPhraseGroupsMassActionsAction
    | HandleGroupsEditMassActions;
